import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ContextMenu as ContextMenuLocal, Item, MenuButton } from 'basic-components';
import { Menu as MenuIcon } from 'basic-components/icons';

const ContextMenu = ({ openDefaultColumnsList, setDefaultColumns, setIsMenuOpen }) => {
  const onMenuChange = useCallback(({ open }) => setIsMenuOpen(open), [setIsMenuOpen])

  return (
    <ContextMenuLocal
        className="ng-office-app__authed__content__basket__body__data__basket__headers__header__settings__header__right__context-menu"
        itemsSize="unset"
        menuButton={(
          <MenuButton key="MenuButton">
            <div className="ng-office-app__authed__content__basket__body__data__basket__headers__header__settings__header__right__context-menu__icon">
              <MenuIcon
                  color="blue-bright"
                  height={16}
                  width={16}
              />
            </div>
          </MenuButton>
        )}
        onMenuChange={onMenuChange}
        portal
    >
      <Item onClick={openDefaultColumnsList}>
        Default columns list
      </Item>
      <Item onClick={setDefaultColumns}>
        Reset
      </Item>
    </ContextMenuLocal>
  )
}

ContextMenu.propTypes = {
  openDefaultColumnsList: PropTypes.func.isRequired,
  setDefaultColumns: PropTypes.func.isRequired,
  setIsMenuOpen: PropTypes.func.isRequired
}

export default ContextMenu;
